<template>
	<v-card>
		<v-card-title>
			<span>{{ uppercaseName }}</span>
			<v-spacer></v-spacer>
			<v-btn
				class="mx-2"
				small
				color="primary"
				@click="checkConfirmationDialog"
			>
				<v-icon dark>
					mdi-window-close
				</v-icon>
			</v-btn>
		</v-card-title>

		<v-card-text>
			<v-container class="questions-container p-5" v-if="questions.length">
				<div class="mb-5 pb-5">
					<p class="quiz-duration">
						{{ $t("questionsView.quizDuration") }}:
						<span class="quiz-time"
							>{{ quiz.duration_in_minutes }}
							<span v-if="quiz.duration_in_minutes > 1">{{
								$t("questionsView.minutes")
							}}</span
							><span v-else>{{ $t("questionsView.minute") }}</span></span
						>
					</p>
					<p class="quiz-duration" v-if="exam">
						{{ $t("questionsView.timer") }}:
						<span class="quiz-time">{{ calcTime }}</span>
					</p>
				</div>
				<div v-if="!exam">
					<div
						v-for="(question, index) of questions"
						:key="question.id"
						class="question"
					>
						<h4>{{ $t("questionsView.q") }}.{{ index + 1 }}</h4>
						<p class="question-title">{{ question.question_title }}</p>
						<v-radio-group v-model="answers[index]">
							<v-radio
								v-if="question.option1"
								:label="question.option1"
								color="green"
								:value="question.option1"
							></v-radio>
							<v-radio
								v-if="question.option2"
								:label="question.option2"
								color="green"
								:value="question.option2"
							></v-radio>
							<v-radio
								v-if="question.option3"
								:label="question.option3"
								color="green"
								:value="question.option3"
							></v-radio>
							<v-radio
								v-if="question.option4"
								:label="question.option4"
								color="green"
								:value="question.option4"
							></v-radio>
						</v-radio-group>
						<hr v-if="index < questions.length - 1 && !exam" />
					</div>
				</div>
				<div v-else>
					<div
						v-for="(question, index) of questions"
						:key="question.id"
						class="question"
					>
						<div v-if="current_question == index">
							<h4 :class="`q-${index}`">Q.{{ index + 1 }}</h4>
							<p class="question-title">{{ question.question_title }}</p>
							<v-radio-group v-model="answers[index]">
								<v-radio
									v-if="question.option1"
									:label="question.option1"
									color="green"
									value="1"
								></v-radio>
								<v-radio
									v-if="question.option2"
									:label="question.option2"
									color="green"
									value="2"
								></v-radio>
								<v-radio
									v-if="question.option3"
									:label="question.option3"
									color="green"
									value="3"
								></v-radio>
								<v-radio
									v-if="question.option4"
									:label="question.option4"
									color="green"
									value="4"
								></v-radio>
							</v-radio-group>
						</div>
					</div>
				</div>
			</v-container>
			<v-container
				v-else
				class="d-flex justify-content-center align-items-center"
			>
				<h4>
					{{ $t("noQuestionsExist") }}
				</h4>
			</v-container>
		</v-card-text>

		<v-card-actions v-if="exam && questions.length">
			<v-spacer></v-spacer>
			<v-btn
				color="red darken-1"
				text
				@click="--current_question"
				:disabled="current_question == 0"
			>
				<v-icon class="mx-1" dense>
					mdi-chevron-left
				</v-icon>
				{{ $t("Back") }}
			</v-btn>
			<v-btn
				color="green darken-1"
				text
				@click="nextQuestion"
				:disabled="!this.answers[this.current_question]"
			>
				{{ submitText }}
				<v-icon
					class="mx-1"
					dense
					v-if="current_question != questions.length - 1"
				>
					mdi-chevron-right
				</v-icon>
			</v-btn>
			<v-spacer></v-spacer>
		</v-card-actions>

		<v-dialog v-model="confirmationDialog" persistent max-width="400px">
			<v-card>
				<v-card-title class="text-h5">
					{{ $t("questionsView.areYouSure") }}
				</v-card-title>
				<v-card-text class="text-center">
					{{ $t("questionsView.submissionAssurance") }}
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="red darken-1" text @click="confirmationDialog = false">
						{{ $t("cancel") }}
					</v-btn>
					<v-btn color="green darken-1" text @click="submitQuiz">
						{{ $t("yes") }}
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="resultDialog" persistent max-width="400px">
			<v-card>
				<v-card-title class="text-h5">
					{{ $t("questionsView.yourResult") }}
				</v-card-title>
				<v-card-text class="text-center">
					{{ result }}
					<h4 class="text-center mt-5">
						{{ $t("questionsView.yourScore") }}: {{ score }}
					</h4>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green darken-1 w-100 text-white" @click="endQuiz">
						{{ $t("close") }}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="timeExpiredDialog" persistent max-width="400px">
			<v-card>
				<v-card-title class="text-h5">
					{{ $t("questionsView.timeIsExpired") }}
				</v-card-title>
				<v-card-text class="text-center">
					{{ $t("questionsView.timeNote") }}
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="green darken-1 w-100 text-white" @click="endQuiz">
						{{ $t("close") }}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="confirmCloseDialog" persistent max-width="400px">
			<v-card>
				<v-card-title class="text-h5">
					{{ $t("questionsView.areYouSure") }}
				</v-card-title>
				<v-card-text class="text-center">
					{{ $t("questionsView.closeConfirmation") }}
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="red darken-1" text @click="confirmCloseDialog = false">
						{{ $t("cancel") }}
					</v-btn>
					<v-btn color="green darken-1" text @click="endQuiz">
						{{ $t("yes") }}
					</v-btn>
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import GlobalMixin from "@/GlobalMixin.js";
import moment from "moment";

export default {
	name: "QuizModal",
	mixins: [GlobalMixin],
	props: ["quiz", "questions", "previewDialog", "exam"],
	emits: ["closeDialog"],
	data() {
		return {
			student: this.$store.getters.StateUser?.user,
			answers: [],
			current_question: 0,

			// dialogs
			confirmationDialog: false,
			resultDialog: false,
			timeExpiredDialog: false,
			confirmCloseDialog: false,

			// Result
			result: null,
			score: null,

			// Timer
			interval: null,
			time: null,
			timerStarted: false,
			timeLeft: null,
		};
	},
	/**
	 * Initialize component for first time
	 */
	mounted() {
		this.time = this.quiz?.duration_in_minutes;
		this.timeLeft = this.quiz?.duration_in_minutes * 60;
	},
	methods: {
		/**
		 * Get next question
		 */
		nextQuestion() {
			if (this.current_question != this.questions.length - 1)
				return ++this.current_question;

			// Show Confirmation dialog
			this.confirmationDialog = true;
		},
		/**
		 * Submit answers of quiz
		 */
		submitQuiz() {
			this.confirmationDialog = false;

			const institute_id = +this.student.username.split("").at(-1);
			const questions = this.answers.map((a, index) => ({
				question_id: this.questions[index].id,
				selected_option: +a,
			}));

			const body = {
				questions,
				student_exam: this.exam,
				institute: institute_id,
			};

			this.axios
				.post(
					`${process.env.VUE_APP_APIEndPoint}quiz/take_exam/`,
					body,
					this.headers
				)
				.then(res => {
					this.resultDialog = true;
					this.result = res.data.message;
					this.score = res.data.score;
				});
			return clearInterval(this.interval);
		},

		/**
		 * End quiz
		 */
		endQuiz() {
			if (
				this.timeExpiredDialog ||
				(this.confirmCloseDialog && this.questions.length)
			)
				this.submitQuiz();

			this.resultDialog = false;
			this.timeExpiredDialog = false;
			this.$emit("closeDialog");
		},

		/**
		 * If quiz is preview don't show confrimation dialog
		 */
		checkConfirmationDialog() {
			if (this.exam) return (this.confirmCloseDialog = true);
			this.$emit("closeDialog");
		},
	},
	computed: {
		/**
		 * Make all letters of name uppercased
		 */
		uppercaseName() {
			return this.quiz?.name?.toUpperCase();
		},
		/**
		 * SubmitText to submit the quiz answers
		 */
		submitText() {
			return this.current_question == this.questions.length - 1
				? this.$t("submit")
				: this.$t("Next");
		},
		/**
		 * Calculate Time
		 */
		calcTime() {
			return this.time?.format("HH:mm:ss");
		},
	},
	watch: {
		/**
		 * Reset all values to default
		 * @param newVal boolean which refers to if quiz dialog is now opened or not
		 */
		previewDialog(newVal) {
			if (!newVal) {
				this.answers = [];
				this.current_question = 0;
				this.result = null;
				this.score = null;

				// For Timer
				this.time = null;
				this.timerStarted = false;
			}
		},

		/**
		 * Starts new quiz if quiz changed
		 */
		quiz() {
			clearInterval(this.interval);
			this.time =
				this.quiz?.duration_in_minutes >= 60
					? moment(this.quiz?.duration_in_minutes / 60, "hh:mm:ss")
					: moment(this.quiz?.duration_in_minutes, "mm:ss");
			this.timeLeft = this.quiz?.duration_in_minutes * 60;
			this.interval = setInterval(() => {
				--this.timeLeft;
				this.time = moment(this.time.subtract(1, "seconds"));
			}, 1000);
		},

		/**
		 * Start timer if first time open quiz dialog
		 * @param newVal quiz number of minutes
		 * @param oldVal quiz number of minutes
		 */
		time(newVal, oldVal) {
			if (this.timerStarted) return;

			this.timerStarted = true;
			this.time =
				this.quiz?.duration_in_minutes >= 60
					? moment(this.quiz?.duration_in_minutes / 60, "hh:mm:ss")
					: moment(this.quiz?.duration_in_minutes, "mm:ss");
			this.interval = setInterval(() => {
				--this.timeLeft;
				this.time = moment(this.time.subtract(1, "seconds"));
			}, 1000);
		},

		/**
		 * Start reducing timeLeft with 1 second until it reaches 0 seconds then timeExpiredDialog will be open and submit the quiz automatically
		 * @param newVal number of time left with seconds
		 */
		timeLeft(newVal) {
			if (isNaN(newVal)) return;
			if (!newVal) {
				this.timeExpiredDialog = true;
				return clearInterval(this.interval);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
* {
	color: #000;
}
.questions-container {
	border: 1px solid;
	border-radius: 5px;

	.quiz-duration {
		font-weight: 500;
		font-size: 24px;
		.quiz-time {
			font-weight: 300;
			font-size: 18px;
		}
	}
	.question {
		.question-title {
			font-size: 18px;
		}
	}
	hr {
		margin-top: 30px;
	}
}
</style>
